import { StyledButton } from 'components/elements/Button/Button.styled';
import { StyledIconButton } from 'components/elements/IconButton/IconButton.styled';
import { styled } from 'styles';

export const StyledCardActions = styled.div`
  background-color: ${({ theme }) => theme.card.actions.background};
  display: flex;
  justify-content: flex-end;
  padding: ${({ theme }) => theme.spacing.absolute.smaller}
    ${({ theme }) => theme.spacing.absolute.medium};

  ${StyledButton}:not(${StyledIconButton}) {
    min-width: 7em;
  }

  ${StyledButton} + ${StyledButton} {
    margin: 0 0 0 ${({ theme }) => theme.spacing.absolute.smaller};
  }

  @media (max-width: 576px) {
    flex-direction: column;

    ${StyledButton} {
      display: block;
      width: unset;
    }

    ${StyledButton} + ${StyledButton} {
      margin: ${({ theme }) => theme.spacing.absolute.smaller} 0 0 0;
    }
  }
`;

StyledCardActions.displayName = 'CardActions';
